import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';
import {
  FETCH_PROPOSALS,
  ADD_ACCOMMODATION,
  ADD_ACCOMMODATION_FROM_ALTERNATIVES,
  ADD_TRANSPORT,
  FETCH_PROPOSALS_FROM_EDIT_CRITERIA,
} from 'Store/booking/proposals/constants';
import { START_LOADING, END_LOADING } from 'Store/global-loader/globalLoader.action';
type State = string;
const initialState: State = '';

function LabelReducer(state: State = initialState, action: Action<any> | null | undefined): State {
  switch (get(action, 'type')) {
    case START_LOADING:
    case ADD_ACCOMMODATION:
    case ADD_ACCOMMODATION_FROM_ALTERNATIVES:
    case ADD_TRANSPORT:
    case FETCH_PROPOSALS:
    case FETCH_PROPOSALS_FROM_EDIT_CRITERIA:
      return get(action, 'payload.globalLoaderLabel', null);

    case END_LOADING:
    case resolve(ADD_ACCOMMODATION):
    case reject(ADD_ACCOMMODATION):
    case resolve(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case reject(ADD_ACCOMMODATION_FROM_ALTERNATIVES):
    case resolve(ADD_TRANSPORT):
    case reject(ADD_TRANSPORT):
    case reject(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
    case reject(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
      return initialState;

    default:
      return state;
  }
}

export default LabelReducer;
